module.exports = __webpack_public_path__ + "img/66ne.ee7ee33f.svg";